import { Injectable } from "@angular/core";
import { merge, of, switchMap } from "rxjs";
import { UserService } from "@/_services/user.service";
import { subscriptionCacheNotifier$ } from "@/_services/cache-notifiers";
import { getInstance } from "@features/instance";

@Injectable({ providedIn: "root" })
export class FeatureContextService {
    constructor(private userService: UserService) {
        merge(of(null), subscriptionCacheNotifier$)
            .pipe(switchMap(() => this.userService.getCurrentUserAsync()))
            .subscribe((user) => {
                if (!user?.account?._id) {
                    return;
                }
                getInstance().setContext({
                    accountId: user.account._id,
                    isBetaTester: user.account.isBetaTester,
                    features: user.account.features ?? [],
                });
            });
    }
}
